export default __webpack_public_path__ + "static/media/TLSA.2ff68e35.png";